import { CommanderThunkAction } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { anonymizeUrl } from '@mews-commander/utils';
import { trackEvent } from '../../middleware/createAnalyticsMiddleware';
import { navigateInBaseModal } from '../app/actions/common';
import { prefix } from './module';

export const CLOSE_APP_SIDEBAR = prefix('CLOSE_APP_SIDEBAR');
export const OPEN_APP_SIDEBAR = prefix('OPEN_APP_SIDEBAR');

const EVENT_CATEGORY = 'AppSidebar';

export const closeAppSidebar = (): CommanderThunkAction => (dispatch) => {
    dispatch(trackEvent({ eventCategory: EVENT_CATEGORY, eventAction: 'closed' }));
    dispatch(createAction(CLOSE_APP_SIDEBAR));
};
export const openAppSidebar = (): CommanderThunkAction => (dispatch) => {
    dispatch(trackEvent({ eventCategory: EVENT_CATEGORY, eventAction: 'opened' }));
    dispatch(createAction(OPEN_APP_SIDEBAR));
};
export const redirectInModal =
    (url: string): CommanderThunkAction =>
    (dispatch) => {
        dispatch(
            trackEvent({ eventCategory: EVENT_CATEGORY, eventAction: 'link clicked', eventLabel: anonymizeUrl(url) })
        );
        dispatch(navigateInBaseModal(url));
    };
